import { MenuItem, Select } from "@mui/material";
import { nanoid } from "nanoid";

const CaltexUnitSelect = (props) => {

    return (
        <Select
            value={props.value}
            onChange={props.onChange}
            defaultValue={props.value}
            variant="standard"
            sx={{ ...props.style }}
        >
            {props.units && props.units.length > 0
                ? props.units.map((unit) => (
                      <MenuItem value={unit} key={nanoid()}>
                          {unit}
                      </MenuItem>
                  ))
                : null}
        </Select>
    );
};

export default CaltexUnitSelect;
